import AsoHeader from "../../../components/Aso/Header";
import AsoRazaoSocial from "../../../components/Aso/Register/AsoRazaoSocial";

const AsoRegistroRazaoSocial = () => {
    return(
        <>
            <AsoHeader />
            <AsoRazaoSocial />
        </>
    );
}

export default AsoRegistroRazaoSocial;